import React, { useMemo } from 'react'
import { FiEdit, FiX } from 'react-icons/fi'

import { t } from 'i18next'

import { Button } from '~/components/Buttons'

type EditButtonProps = {
  isActive: boolean
  onClick(): void
}

const activeProps = {
  text: t('rm:button.Editing'),
  template: 'warning',
  size: 'xsmall',
  customWidth: 'auto',
  iconRight: <FiX />
} as ButtonProps

const defaultProps = {
  text: t('rm:button.Edit'),
  size: 'xsmall',
  customWidth: 'auto',
  template: 'secondary',
  iconLeft: <FiEdit />
} as ButtonProps

const EditButton = ({ isActive, ...rest }: EditButtonProps) => {
  const props = useMemo(
    () => (isActive ? activeProps : defaultProps),
    [isActive]
  )

  return <Button {...props} {...rest} />
}

export default EditButton
